/* eslint-disable indent */
/* eslint-disable space-infix-ops */
import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import { Wrapper } from '../styled';

const BrowserWrapper = styled.div`
  width: 100%;

  @media ${device.laptop} {
    padding: 50px 0;
    padding-left: 50px;
    width: 50%;
  }

  @media ${device.laptopL} {
    width: 60%;
  }
`;

const ContentWrapper = styled(Flex).attrs({
  direction: 'column',
})`
  align-items: center;
  margin-bottom: 20px;

  @media ${device.laptop} {
    align-items: flex-start;
    margin-bottom: 0;
    padding-right: 50px;
    width: 50%;
  }

  @media ${device.laptopL} {
    width: 40%;
  }
`;

interface SectionWrapperProps {
  reverse?: boolean;
}

const SectionWrapper = styled(Wrapper)<SectionWrapperProps>`
  align-items: center;

  @media ${device.laptop} {
    align-items: center;
    flex-direction: row;

    ${({ reverse }) =>
      reverse &&
      css`
        flex-direction: row-reverse;
        ${BrowserWrapper} {
          padding-left: 0;
          padding-right: 50px;
        }

        ${ContentWrapper} {
          padding-left: 50px;
          padding-right: 0;
        }
      `}
  }
`;

const Title = styled(Text).attrs({
  as: 'h2',
  size: '40px',
  family: 'bold',
})`
  text-align: center;
  margin: auto;
  margin-bottom: 20px;

  @media ${device.laptop} {
    text-align: left;
    margin: unset;
    margin-bottom: 20px;
  }
`;

const Description = styled(Text).attrs({
  height: 1.3,
  color: color.dimgray,
})`
  font-size: 16px;
  margin: auto;
  text-align: center;

  @media ${device.laptop} {
    font-size: 18px;
    margin: unset;
    text-align: left;
  }
`;

export { SectionWrapper, BrowserWrapper, ContentWrapper, Title, Description };
